import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import type { AnalysisResult } from '../types';

interface ReportCardProps {
  result: AnalysisResult;
  snapshotUrl: string | null;
  onSave: () => void;
  onShare: () => void;
  onAgain?: () => void;
  saveDisabled?: boolean;
}

export const ReportCard = forwardRef<HTMLDivElement, ReportCardProps>(
  ({ result, snapshotUrl, onSave, onShare, onAgain, saveDisabled }, ref) => {
    return (
      <motion.div
        ref={ref}
        className="report-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <div className="report-image">
          {snapshotUrl ? (
            <img src={snapshotUrl} alt="拍摄画面" />
          ) : (
            '🐕'
          )}
        </div>
        <div className="report-body">
          <div className="report-row breed">
            <span className="dot" aria-hidden />
            <div>
              <div className="label">谁家的小可爱</div>
              <div className="value">{result.breed}</div>
              <div className="meta">{result.breedMeta}</div>
            </div>
          </div>
          <div className="report-row emotion">
            <span className="dot" aria-hidden />
            <div>
              <div className="label">TA 的小情绪</div>
              <div className="value">{result.emotion}</div>
              <div className="meta">{result.emotionMeta}</div>
            </div>
          </div>
          <div className="report-row health">
            <span className="dot" aria-hidden />
            <div>
              <div className="label">体型如何</div>
              <div className="value">{result.health}</div>
              <div className="meta">{result.healthMeta}</div>
            </div>
          </div>
        </div>
        <div className="report-actions">
          <button
            type="button"
            className="btn btn-capture"
            onClick={onSave}
            disabled={saveDisabled}
            aria-label="保存这一刻"
          >
            <span className="btn-icon" aria-hidden>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </span>
            <span>保存这一刻</span>
          </button>
          <button
            type="button"
            className="btn btn-share"
            onClick={onShare}
            aria-label="分享给朋友"
          >
            <span className="btn-icon" aria-hidden>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </span>
            <span>分享给朋友</span>
          </button>
        </div>
        {onAgain && (
          <div className="report-again-wrap">
            <button
              type="button"
              className="btn-again"
              onClick={onAgain}
              aria-label="再拍一次"
            >
              再拍一次
            </button>
          </div>
        )}
      </motion.div>
    );
  }
);

ReportCard.displayName = 'ReportCard';
